<template>
  <footer class="footer">
    <div class="info-wrapper">
      <i class="logo"></i>
      <div class="copyright">
        <p>
          Copyright 2015-{{ date }} 深圳市迷你玩科技有限公司 , All Rights
          Reserved.
        </p>
        <p>《网络文化经营许可证》 浙粤网文[2016]1349-302号</p>
      </div>
      <div class="code" v-if="showQrCode">
        <img src="../../assets/images/code.png" />
        <div class="title">迷你世界开发者公众号</div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import { isPc } from '../../utils/ua';
// const whiteList = [
//   842180093, 47713237, 1073936555, 1005, 1052808151, 795220124, 1183107198,
//   1172998159, 1316409178, 193866135, 551762897, 768705217, 1352051181
// ];
export default {
  data() {
    return {
      date: 2022,
    };
  },
  computed: {
    ...mapState(['userInfo']),
    showQrCode() {
      return isPc;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let date = new Date().getFullYear();
      if (this.userInfo) {
        if (this.userInfo.st) {
          date = new Date(this.userInfo.st * 1000).getFullYear();
        }
      }
      if (date) {
        this.date = date;
      }
    },
    jumpMobile() {
      const paddingUrl = process.env.VUE_APP_ENV === 'prod' ? '' : '-test';
      location.href = `https://kfz${paddingUrl}.mini1.cn/m/#/`;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  height: 150px;
  background: #3a3a3a;

  .info-wrapper {
    display: flex;
    justify-content: center;
    padding-top: 40px;
  }

  .logo {
    width: 40px;
    height: 40px;
    margin-top: -8px;
    margin-right: 24px;
    background: url(~@/assets/images/logo.png) no-repeat;
  }

  .copyright {
    font-size: 16px;
    line-height: 30px;
    text-align: center;
    color: #ffffff;
  }
  .code {
    margin-top: -20px;
    margin-left: 63px;
    img {
      margin-left: 26px;
    }
    .title {
      line-height: 29px;
      color: #ffffff;
      //  letter-spacing: 60px;
      opacity: 1;
      font-size: 14px;
    }
  }
  .jumpMobile {
    color: #fff;
    cursor: pointer;
  }
}
</style>
